import { SDK_VERSION } from "../constants/sdk-version.qwik.mjs";
import { TARGET } from "../constants/target.qwik.mjs";
const getSdkHeaders = () => ({
  "X-Builder-SDK": TARGET,
  "X-Builder-SDK-GEN": "2",
  "X-Builder-SDK-Version": SDK_VERSION
});
export {
  getSdkHeaders
};
